// src/composables/useUpdateChecker.js
const POLL_INTERVAL_MS = 60_000; // check every 60s
let currentVersion = null;

function getMetaVersion() {
  return document
    .querySelector('meta[name="app-version"]')
    ?.getAttribute('content');
}

async function fetchRemoteVersion() {
  try {
    const res = await fetch('/index.html', { cache: 'no-store' });
    const html = await res.text();

    // Extract <meta name="app-version" content="...">
    const match = html.match(
      /<meta\s+name=["']app-version["']\s+content=["']([^"']+)["']/
    );
    return match ? match[1] : null;
  } catch (e) {
    console.warn('Failed to fetch remote version', e);
    return null;
  }
}

async function initVersion() {
  currentVersion = getMetaVersion();
  console.info('Current app version:', currentVersion);
}

async function pollForUpdate() {
  const remoteVersion = await fetchRemoteVersion();

  if (remoteVersion && currentVersion && remoteVersion !== currentVersion) {
    console.info(
      `New version detected (local=${currentVersion}, remote=${remoteVersion}). Reloading...`
    );
    window.location.reload();
  }
}

export async function startUpdateChecker() {
  await initVersion();
  setInterval(pollForUpdate, POLL_INTERVAL_MS);
}
